var _defs, _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5832",
    "data-name": "Group 5832",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200.268,
    height: 119.206,
    viewBox: "0 0 200.268 119.206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1800",
    "data-name": "Rectangle 1800",
    width: 200.268,
    height: 119.206,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    width: 8.612,
    height: 8.612,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    "data-name": "Rectangle 1793",
    width: 6.447,
    height: 2.801,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    width: 0.01,
    height: 0.019,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1795",
    "data-name": "Rectangle 1795",
    width: 8.416,
    height: 3.498,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1796",
    "data-name": "Rectangle 1796",
    width: 7.921,
    height: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8617",
    "data-name": "Path 8617",
    d: "M108.157,77.069,108.142,90.8a3.864,3.864,0,0,1-4.748,3.725,16.661,16.661,0,0,0-20,13.863,13.159,13.159,0,0,0-9.338,6.491,9.816,9.816,0,0,0-5.266-.719,9.862,9.862,0,0,0-7.074,14.9c-.155-.016-.313-.025-.474-.025a4.766,4.766,0,0,0-4.714,4.025,12.663,12.663,0,0,0-24.5,4.2,23.213,23.213,0,0,0-15.718-5.737A22.956,22.956,0,0,0,0,138.763H200.267a32.855,32.855,0,0,0-32.1-1.732,13.248,13.248,0,0,0-15.861-4.678A18.264,18.264,0,0,0,134.8,116.521a13.228,13.228,0,0,0-13.06-15.624h-.05A4.693,4.693,0,0,1,117,96.208l.021-19.139Z",
    transform: "translate(0 -77.069)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5831",
    "data-name": "Group 5831",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5826",
    "data-name": "Group 5826"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5825",
    "data-name": "Group 5825",
    clipPath: "url(#clip-path)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8596",
    "data-name": "Path 8596",
    d: "M132.361,64.054a7.749,7.749,0,0,0,7.388,5.415H152.53a7.749,7.749,0,0,0,7.388-5.415Z",
    transform: "translate(-33.588 -16.254)",
    fill: "#0076b3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8597",
    "data-name": "Path 8597",
    d: "M152.713,75.608h-8.151A1.559,1.559,0,0,1,143,74.049V71.311h11.269v2.738a1.559,1.559,0,0,1-1.559,1.559",
    transform: "translate(-36.288 -18.096)",
    fill: "#5c5c5f"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1791",
    "data-name": "Rectangle 1791",
    width: 11.27,
    height: 1.413,
    transform: "translate(106.714 53.215)",
    fill: "#49484b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8598",
    "data-name": "Path 8598",
    d: "M146.063,77.069a7.7,7.7,0,0,0,.958,4.166l2.052,3.691a.433.433,0,0,0,.757,0l2.052-3.691a7.7,7.7,0,0,0,.958-4.166Z",
    transform: "translate(-37.062 -19.557)",
    fill: "#ec671c"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8599",
    "data-name": "Path 8599",
    d: "M147.3,77.069a6.743,6.743,0,0,0,.842,3.716l1.621,2.916,1.622-2.916a6.744,6.744,0,0,0,.842-3.716Z",
    transform: "translate(-37.376 -19.557)",
    fill: "#f3e600"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8600",
    "data-name": "Path 8600",
    d: "M138.4,67.6a2.843,2.843,0,0,0,2.625,1.866H153.98a2.826,2.826,0,0,0,2.529-1.62,6.084,6.084,0,0,0,.631-2.588V64.054H138v1.207a7.024,7.024,0,0,0,.4,2.34",
    transform: "translate(-35.02 -16.254)",
    fill: "#0098d2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8601",
    "data-name": "Path 8601",
    d: "M136.19,46.074a18.533,18.533,0,0,0,.575-3.92,47.1,47.1,0,0,1-.89-7.48c-.038-.146-.077-.29-.118-.435a21.122,21.122,0,0,0-2.752-5.878,25.887,25.887,0,0,0-11.04,21.205v8.685l0,0a27.727,27.727,0,0,1,10.2-4.16,20.6,20.6,0,0,0,4.031-8.02",
    transform: "translate(-30.949 -7.197)",
    fill: "#1da193"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8602",
    "data-name": "Path 8602",
    d: "M135.626,62.844h0",
    transform: "translate(-34.416 -15.947)",
    fill: "#49484b"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8603",
    "data-name": "Path 8603",
    d: "M128.345,53.51a7.734,7.734,0,0,0,.3,2.107,37.317,37.317,0,0,1,5.136-1.525,20.6,20.6,0,0,0,4.031-8.02,18.572,18.572,0,0,0,.575-3.92,47,47,0,0,1-.89-7.48c-.038-.146-.077-.29-.118-.434a21.117,21.117,0,0,0-2.752-5.879,25.879,25.879,0,0,0-5.358,5.038,50.219,50.219,0,0,0-.922,9.579Z",
    transform: "translate(-32.569 -7.196)",
    fill: "#138959"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8604",
    "data-name": "Path 8604",
    d: "M160.427,46.074a18.58,18.58,0,0,1-.575-3.92,47.012,47.012,0,0,0,.89-7.48c.038-.146.077-.29.118-.435a21.122,21.122,0,0,1,2.752-5.878,25.887,25.887,0,0,1,11.04,21.205v8.685l0,0a27.727,27.727,0,0,0-10.2-4.16,20.6,20.6,0,0,1-4.031-8.02",
    transform: "translate(-40.564 -7.197)",
    fill: "#1da193"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8605",
    "data-name": "Path 8605",
    d: "M166.024,62.844h0",
    transform: "translate(-42.13 -15.947)",
    fill: "#49484b"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8606",
    "data-name": "Path 8606",
    d: "M169.891,53.51a7.734,7.734,0,0,1-.3,2.107,37.319,37.319,0,0,0-5.136-1.525,20.6,20.6,0,0,1-4.031-8.02,18.574,18.574,0,0,1-.575-3.92,47,47,0,0,0,.89-7.48c.038-.146.077-.29.118-.434a21.137,21.137,0,0,1,2.752-5.879,25.88,25.88,0,0,1,5.358,5.038,50.22,50.22,0,0,1,.922,9.579Z",
    transform: "translate(-40.564 -7.196)",
    fill: "#138959"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8607",
    "data-name": "Path 8607",
    d: "M146.018,0h0a50.232,50.232,0,0,0-14.137,34.934V45.469a7.746,7.746,0,0,0,7.746,7.746h12.782a7.746,7.746,0,0,0,7.746-7.746V34.934A50.232,50.232,0,0,0,146.018,0",
    transform: "translate(-33.466)",
    fill: "#64d89b"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8608",
    "data-name": "Path 8608",
    d: "M158.442,19.01A50.224,50.224,0,0,0,146.9,0a50.214,50.214,0,0,0-11.542,19.01Z",
    transform: "translate(-34.348)",
    fill: "#138959"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8609",
    "data-name": "Path 8609",
    d: "M147.571,29.446h0A9.568,9.568,0,0,0,138,39.014V55.272H157.14V39.014a9.569,9.569,0,0,0-9.568-9.568",
    transform: "translate(-35.02 -7.472)",
    fill: "#def1fb"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8610",
    "data-name": "Path 8610",
    d: "M155.774,40.287a7.5,7.5,0,1,0-7.5,7.5,7.5,7.5,0,0,0,7.5-7.5",
    transform: "translate(-35.724 -8.321)",
    fill: "#138959"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8611",
    "data-name": "Path 8611",
    d: "M154.95,40.712a6.25,6.25,0,1,0-6.251,6.251,6.25,6.25,0,0,0,6.251-6.251",
    transform: "translate(-36.148 -8.745)",
    fill: "#64d89b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5812",
    "data-name": "Group 5812",
    transform: "translate(108.246 27.66)",
    opacity: 0.8,
    style: {
      mixBlendMode: "color-burn",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5811",
    "data-name": "Group 5811"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5810",
    "data-name": "Group 5810",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8612",
    "data-name": "Path 8612",
    d: "M153.667,41.373a4.306,4.306,0,1,0-4.306,4.307,4.306,4.306,0,0,0,4.306-4.307",
    transform: "translate(-145.055 -37.066)",
    fill: "#14172c"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5815",
    "data-name": "Group 5815",
    transform: "translate(108.521 27.66)",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5814",
    "data-name": "Group 5814"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5813",
    "data-name": "Group 5813",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8613",
    "data-name": "Path 8613",
    d: "M145.424,39.867l6.447-2.06c-.081-.055-.166-.1-.251-.154-.046-.027-.09-.054-.137-.08-.113-.061-.23-.118-.349-.169l-.01,0a4.3,4.3,0,0,0-5.7,2.466",
    transform: "translate(-145.424 -37.066)",
    fill: "#49484b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5818",
    "data-name": "Group 5818",
    transform: "translate(116.344 29.928)",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5817",
    "data-name": "Group 5817"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5816",
    "data-name": "Group 5816",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8614",
    "data-name": "Path 8614",
    d: "M155.912,40.112c-.007-.013-.006-.01.005.013h0l-.006-.012",
    transform: "translate(-155.907 -40.105)",
    fill: "#49484b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5821",
    "data-name": "Group 5821",
    transform: "translate(108.285 29.947)",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5820",
    "data-name": "Group 5820"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5819",
    "data-name": "Group 5819",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8615",
    "data-name": "Path 8615",
    d: "M145.334,43.629l8.189-2.616a5.676,5.676,0,0,0-.348-.882l-8.068,2.577a4.3,4.3,0,0,0,.226.922",
    transform: "translate(-145.108 -40.131)",
    fill: "#49484b"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5824",
    "data-name": "Group 5824",
    transform: "translate(108.938 31.773)",
    opacity: 0.8,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5823",
    "data-name": "Group 5823"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5822",
    "data-name": "Group 5822",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8616",
    "data-name": "Path 8616",
    d: "M153.9,42.768c0-.065-.007-.128-.01-.191v0l-7.911,2.527a4.3,4.3,0,0,0,7.726-1.056c.016-.052.028-.107.042-.16.022-.084.047-.166.064-.251a4.292,4.292,0,0,0,.089-.87v0",
    transform: "translate(-145.982 -42.577)",
    fill: "#49484b"
  }))))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5828",
    "data-name": "Group 5828",
    transform: "translate(0 57.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5827",
    "data-name": "Group 5827",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_1798",
    "data-name": "Rectangle 1798",
    width: 200.739,
    height: 61.938,
    transform: "translate(0 -0.244)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAQ0AAABTCAYAAACF4VI7AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAIeSURBVHhe7dThxhgEAIXhr7voCiIjiRmJyciYyMTEjCQyZmwzJhKZkUhkImNiUhKJSSQmI5GYGRMTk0j3MIfz/3QBz/PrvYL3qae/vvjfAcD/lGn82waYMo1/2gBTpvF3G2DKNB63AaZM4682wJRpPGoDTJnGn22AKdN42AaYMo0HbYAp07jfBpgyjXttgCnT+KMNMGUav7cBpkzjtzbAlGn82gaYMo27bYAp0/ilDTBlGnfaAFOm8XMbYMo0fmoDTJnGj22AKdP4oQ0wZRq32wBTpvF9G2DKNL5rA0yZxrdtgCnT+KYNMGUaX7UBpkzjyzbAlGncagNMmcYXbYAp07jZBpgyjRttgCnT+LwNMGUan7UBpkzjehtgyjQ+bQNMmcYnbYAp0/i4DTBlGh+1AaZM48M2wJRpXGsDTJnG1TbAlGl80AaYMo332wBTpvFeG2DKNN5tA0yZxpU2wJRpXG4DTJnGpTbAlGlcaANMmcb5NsCUaZxrA0yZxtk2wJRpvNMGmDKNt9sAU6bxVhtgyjTebANMmcaZNsCUaZxuA0yZxhttgCnTONUGmDKN19sAU6Zxsg0wZRqvtQGmTOPVNsCUaZxoA0yZxvE2wJRpvNIGmDKNY22AKdN4uQ0wZRpH2wBTpvFSG2DKNF5sA0yZxpE2wJRpHG4DTJnGC22AKdN4vg0wZRrPtQGmTONQG2DKNJ5tA0yZxjNtgOHg4Al0TpEyK3cG2QAAAABJRU5ErkJggg=="
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5830",
    "data-name": "Group 5830"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5829",
    "data-name": "Group 5829",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8618",
    "data-name": "Path 8618",
    d: "M151.5,21.2a1.027,1.027,0,1,0-1.027,1.027A1.027,1.027,0,0,0,151.5,21.2",
    transform: "translate(-37.924 -5.12)",
    fill: "#64d89b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8619",
    "data-name": "Path 8619",
    d: "M142.066,21.2a1.027,1.027,0,1,0-1.027,1.027,1.027,1.027,0,0,0,1.027-1.027",
    transform: "translate(-35.529 -5.12)",
    fill: "#64d89b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8620",
    "data-name": "Path 8620",
    d: "M160.941,21.2a1.027,1.027,0,1,0-1.027,1.027,1.027,1.027,0,0,0,1.027-1.027",
    transform: "translate(-40.319 -5.12)",
    fill: "#64d89b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginImage);
export default __webpack_public_path__ + "static/media/loginImage.2a49ae065603985ee48461ebd9f8269f.svg";
export { ForwardRef as ReactComponent };